import { IAction } from "./Actions";
// import { IUIElement } from './UIElement';
import * as api from "@crochik/pi-api";

export enum TYPE {
    ADDRESS = "address",
    ARRAY = "array",
    CHECKBOX = "checkbox",
    DATE = "date",
    DATETIME = "datetime",
    DICTIONARY = "dictionary",
    EMAIL = "email",
    FILE = "file",
    HIDDEN = "hidden",
    LABEL = "label",
    LOOKUP = "lookup",
    NUMBER = "number",
    PASSWORD = "password",
    PHONE = "phone",
    POSTALCODE = "postalcode", // use postalCode?
    REFERENCE = "reference",
    SELECT = "select",
    TEXT = "text",
    TIME = "time",
    URL = "url",
    RELATEDOBJECTS = "relatedObjects",
    TAGS = "tags",
    CHILDREN = "children",
    DATERANGE = "dateRange",
    OBJECT = "object",
    LOCATION = "location",
    MULTISELECT = "multiSelect",
    MULTIREFERENCE = "multiReference",
    GENERIC = "generic",
    CALCULATED = "calculated",
    LOCATIONDISTANCE = "locationdistance",
    EXPRESSION = "expression",
    BITWISEFLAG = "bitwiseflag",
}

export interface Action extends api.UIElement {
    action?: IAction|null;
}

